import { IPageTeaser } from 'src/models/page-teaser.model';
import { EntityState, IPageTeaserState } from '../app.state';
import { EntityReducer } from '../entity.reducer';
import { fromPageTeaserActions } from './page-teaser.actions';

export const initialState = EntityState.create<IPageTeaser, IPageTeaserState>();
export const pageTeaserReducer = EntityReducer.create<IPageTeaser, IPageTeaserState>(initialState, fromPageTeaserActions);
